/* eslint-disable @typescript-eslint/no-explicit-any */
import useGetList, {
  UseGetListOptions,
} from '@/service-library/core-hooks/useGetList'
import { getList } from '@/service-library/request-wrappers'

type UseForeignKeyListEndpointProps<T = any> = {
  url?: string
  enabled?: boolean
} & Omit<UseGetListOptions<T>, 'queryKey'>

export default function useForeignKeyListEndpoint<T = any>({
  url = '',
  filters,
  enabled,
  ...options
}: UseForeignKeyListEndpointProps<T>) {
  const query = useGetList({
    filters,
    queryKey: [url, filters],
    serviceFn: (serviceFnOptions) => {
      return getList({
        url,
        ...serviceFnOptions,
      })
    },
    enabled: !!(enabled && url),
    ...options,
  })

  return query
}
